module.exports = __webpack_public_path__ + "74e6e6c3dcfca56767adabe83a510f2e.svg";